import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Animation from './Animation';
import Fade from '@material-ui/core/Fade';

const useStyles = makeStyles(
  () => ({
    root: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'rgba(255,255,255,0.5)',
      zIndex: 9999,
      top: 0,
      left: 0,
      overflow: 'hidden',
    },
  }),
  {
    name: 'Loader',
  }
);
const Loader = (props) => {
  const classes = useStyles();
  // eslint-disable-next-line react/prop-types
  const { loading } = props;
  if (!loading) {
    return null;
  } else {
    return (
      <Fade
        in={loading}
        timeout={700}
        style={{
          transitionDelay: loading ? '300ms' : '0ms',
        }}
        unmountOnExit
      >
        <div className={classes.root}>
          <Animation></Animation>
        </div>
      </Fade>
    );
  }
};
Loader.protoTypes = {
  loading: PropTypes.bool,
};

Loader.defaultProps = {
  loading: true,
};

export default Loader;
